import { X } from 'lucide-react';
import { chipRemoveVariants, chipVariants } from '../chip/index.ts';

interface ComboboxChipProps {
  value: string;
  disabled: boolean;
  removeLabel?: (value: string) => string;
  onRemove: () => void;
}

/** One picked value, with the × that takes it back off. */
export function ComboboxChip({
  value,
  disabled,
  removeLabel,
  onRemove,
}: ComboboxChipProps) {
  return (
    <span data-slot='combobox-chip' className={chipVariants()}>
      <span className='truncate'>{value}</span>
      <button
        type='button'
        disabled={disabled}
        aria-label={removeLabel?.(value) ?? value}
        onClick={onRemove}
        className={chipRemoveVariants()}
      >
        <X size={12} aria-hidden='true' />
      </button>
    </span>
  );
}
